<template>
  <!--index body-->
  <div class="index_body">
    <!--product-->
    <div class="main product">
      <div class="web-title">
        <h3><em>产品</em>展示</h3>
        <p>跨越国界的贸易精品，汇聚全球智慧与匠心，引领时代的潮流</p>
      </div>
      <div class="pro-center">
        <div class="product-fl text-center">
          <div class="pro-title"><span>classification</span>
            <p>产品分类</p>
          </div>
          <div class="treebox">
            <ul class="menu">
              <li class="level1" v-for="item of menuList">
                <router-link :to="item.url">{{item.name}}
                  <i class="down"></i>
                </router-link>
              </li>
            </ul>
          </div>

          <Contract/>

        </div>

        <!--pro show-->
        <div class="pro-show-center">
          <div class="pro-show text-center marqueetop" id="marquee2">

            <ul id="marquee2_1">
              <li v-for="item of pList">
                <router-link :to="item.url">
                  <img :src="item.img" />
                </router-link>
                <div class="pro-text clearfix">
                  <span>{{item.name}}</span>
                  <router-link :to="item.url">
                    查看详情+
                  </router-link>
                </div>
              </li>
              <div style="clear: both;"></div>
            </ul>

            <ul id="marquee2_2" class="pro-show">
            </ul>
          </div>
        </div>

        <div style="clear: both;"></div>
      </div>

<!--      <div class="pro-more text-center">
        <div style="float: left;width: 200px;">
          <router-link to="/product">查看更多产品+</router-link>
        </div>
        <div style="float: left;width: 300px;margin-left: 15px;">
          <p> 订购电话： <span>18916006004</span></p>
        </div>
        <div style="clear: both;"></div>
      </div>-->
    </div>

    <!--about-->
    <div class="about">
      <div class="main web-title">
        <h3><em>我们的优势</em></h3>
        <p>OUR ADVANTAGES</p>
      </div>
      <div class="about-center">
        <div class="main">
          <div class="about-img"><img src="@/assets/20220129/1643438921310631.jpg" class="img-responsive"></div>
          <div class="about-text">
            <h4>超低价格</h4>
            <p style="text-indent:30px;">
              上海欧淮贸易公司总部位于德国法兰克福，总公司在欧洲业内发展多年已经具备相当知名度和影响力，相比一般小贸易公司我公司的与欧洲厂家的议价能力更强。通过专业的渠道所有货物直接从欧洲厂家源头采购，减少中间环节。
            </p>
            <h4>超快报价</h4>
            <p style="text-indent:30px;">
              上海欧淮贸易公司拥有众多品牌价格表并与德国总公司系统对接累积了海量的工业备件产品型号价格，通过数据化系统，精准匹配客户需求，实现急速报价。
            </p>
            <h4>超短货期</h4>
            <p style="text-indent:30px;">
              德国仓库拼单发货统一国际物流及清关，物流成本时间成本大幅节约。每周法兰克福-香港空运专线，香港-深圳72小时清关，货期优势较北京、上海等更加快速灵活。
            </p>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>
    </div>

    <!--关于我们-->
    <div class="advantage">
      <div class="ad-title main">
        <h3><em>关于我们</em></h3>
        <p>ABOUT US</p>
      </div>
      <div class="advantage-bg">
        <div class="main advantage-center">
          <p class="ptext">我们一直专注于为中国客户提供德国、法国和意大利等欧洲国家的液压、气动、工业自动化技术领域的设备、零部件和备件跨境代理采购服务。 我们为客户提供从报价准备、代理采购、国际物流、清关到交货的全供应链服务。无论您是零售商、制造商还是最终用户，我们都能最好地满足您简化采购流程以及显着降低和优化成本的要求。我们的使命是倾听客户的具体需求，并提通过持续的产品创新和卓越的运营来提供高性能服务。我们不仅提供欧洲工业设备、零部件、备件的代采购服务，还提供来自德国、法国、意大利等欧洲国家的工业技术解决方案。</p>
          <div class="row ad-1">
            <div class="ad-text">
              <h3>6年</h3>
              <p>6年我们成立于2018年，已经走过了6年</p>
            </div>

            <div class="ad-text">
              <h3>1,000+</h3>
              <p>合作供应商逾1,000+</p>
            </div>

            <div class="ad-text">
              <h3>10,000+</h3>
              <p>为中国客户代采产品超过10000+</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import * as productApi from '@/components/oh/prodcutApi'
import Contract from './Contract.vue'

export default {
  name: 'Index',
  components: {
    Contract
  },
  data() {
    return {
      description: '首页',
      menuList: [],
      pList: []
    }
  },
  created() {
    // this.marqueeStart(2, "up");
    this.menuList = productApi.getProductMenuList()
    console.log('index menuList', this.menuList)
    this.pList = productApi.getPList(7)
    console.log('index pList', this.pList)
  },
  methods: {
    //js无缝滚动代码
    marquee(i, direction) {
      let obj = document.getElementById("marquee" + i);
      let obj1 = document.getElementById("marquee" + i + "_1");
      let obj2 = document.getElementById("marquee" + i + "_2");
      if (direction == "up") {
        if (obj2.offsetTop - obj.scrollTop <= 0) {
          obj.scrollTop -= (obj1.offsetHeight + 20);
        } else {
          let tmp = obj.scrollTop;
          obj.scrollTop++;
          if (obj.scrollTop == tmp) {
            obj.scrollTop = 1;
          }
        }
      } else {
        if (obj2.offsetWidth - obj.scrollLeft <= 0) {
          obj.scrollLeft -= obj1.offsetWidth;
        } else {
          obj.scrollLeft++;
        }
      }
    },
    marqueeStart(i, direction) {
      let obj = document.getElementById("marquee" + i);
      let obj1 = document.getElementById("marquee" + i + "_1");
      let obj2 = document.getElementById("marquee" + i + "_2");
      obj2.innerHTML = obj1.innerHTML;
      let marqueeVar = window.setInterval("marquee(" + i + ", '" + direction + "')", 20);
      obj.onmouseover = function () {
        window.clearInterval(marqueeVar);
      }
      obj.onmouseout = function () {
        marqueeVar = window.setInterval("marquee(" + i + ", '" + direction + "')", 20);
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
